import { useEffect, useMemo, useState } from "react";
import { _Api } from "../api/_call";
import { useParams } from 'react-router-dom';
import "../../admin/setup/printoutStyle.scss";

/** Merge stones with the same name (case-insensitive, trimmed); sum Pcs and Cts. */
const aggregateStonesByName = (stones) => {
  if (!stones?.length) return [];
  const groups = new Map();
  for (const stone of stones) {
    const key = String(stone.stone_name ?? "").trim().toLowerCase() || "__unnamed__";
    const addPcs = Number(stone.Pcs) || 0;
    const addCts = Number(stone.Cts) || 0;
    const existing = groups.get(key);
    if (!existing) {
      groups.set(key, { ...stone, Pcs: addPcs, Cts: addCts });
    } else {
      existing.Pcs = (Number(existing.Pcs) || 0) + addPcs;
      existing.Cts = (Number(existing.Cts) || 0) + addCts;
    }
  }
  return [...groups.values()];
};

/** Weight (ct, g, etc.): 2 decimal places. */
const formatStoneQty = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  if (!Number.isFinite(n)) return "-";
  return n.toFixed(2);
};

/** Piece count: no fixed decimal padding (whole numbers stay integer). */
const formatStonePcs = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  if (!Number.isFinite(n)) return "-";
  if (n === 0) return "-";
  return n % 1 === 0 ? String(Math.trunc(n)) : String(n);
};

const ProductViewer = () => {
  const [productDetail, setProductDetail] = useState({});
  const { product_id, dbname, config_template_id } = useParams();
  const [expend, setExpend] = useState(false)
  const [showProductDetails, setShowProductDetails] = useState(true)
  const [showStoneDetails, setShowStoneDetails] = useState(true)

  const [, setConfigTemplateData] = useState(false)



  useEffect(() => {
    const fetchData = async () => {
      try {
        const postdata = { id: product_id, data: dbname }
        const profile_template_id = config_template_id ? config_template_id : ""
        if (profile_template_id !== "") {
          let profile_data = await _Api({ _id: profile_template_id }, `api/v1/template-printout/getByid`);

          setConfigTemplateData(profile_data.data)
        }
        let res = await _Api(postdata, `api/v1/qr-code/getGeneral`);
        console.log(res)

        const { data } = await res;
        setProductDetail(data)


      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();


  }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [])

  const stonesAggregated = useMemo(
    () => aggregateStonesByName(productDetail.Stones),
    [productDetail.Stones]
  );

  return (

    <>

      <div className="container qr_viewer">
        <div className="row">
          <div className="col-sm-12">
            <h1>{productDetail.name}</h1>

            <div className="row">
              <img src={productDetail.main_image} alt="p-image" className="w-100" />
            </div>
            <p>
              <b>SKU : </b> {productDetail.SKU}<br />

            </p>
            <div className="stone_detail" style={{marginBottom: "24px"}}>
              <div className="stone_detail_header" onClick={() => setExpend(!expend)} style={{cursor:"pointer"}}>
                <b>Description</b>
                <i className={`fa ${expend ? "fa-angle-down" : "fa-angle-up"}`}></i>
              </div>
              <div className="viewer_detail_body" style={{ paddingLeft: "1ch" }}>
                <p className={expend ? "description_product_viewer expend" : "description_product_viewer"}>{productDetail.Description}</p>
              </div>
            </div>


            {productDetail.productdetails && (
              <div className="stone_detail product_details_section">
                <div className="stone_detail_header" onClick={() => setShowProductDetails(p => !p)} style={{cursor:"pointer"}}>
                  <b>Product Details</b>
                  <i className={`fa ${showProductDetails ? "fa-angle-up" : "fa-angle-down"}`}></i>
                </div>
                {showProductDetails && (
                  <div className="viewer_detail_body" style={{ paddingLeft: "1ch" }}>
                    {productDetail.productdetails.metal && (
                      <div className="stone_info_row"><span className="stone_label">Metal</span><span className="stone_value">{productDetail.productdetails.metal}</span></div>
                    )}
                    {productDetail.productdetails.Color && (
                      <div className="stone_info_row"><span className="stone_label">Color</span><span className="stone_value">{productDetail.productdetails.Color}</span></div>
                    )}
                    {productDetail.productdetails.size && (
                      <div className="stone_info_row"><span className="stone_label">Size</span><span className="stone_value">{productDetail.productdetails.size}</span></div>
                    )}
                    {stonesAggregated.length > 0 && (
                      <div className="stone_info_row">
                        <span className="stone_label">Stone</span>
                        <span className="stone_value">
                          {stonesAggregated.map((stone, k) => (
                            <div key={k}>
                              {formatStonePcs(stone.Pcs)}
                              &nbsp;&nbsp;{stone.stone_name || "-"}
                              &nbsp;&nbsp;{formatStoneQty(stone.Cts)} cts
                            </div>
                          ))}
                        </span>
                      </div>
                    )}
                    {productDetail.productdetails.grosswt && (
                      <div className="stone_info_row"><span className="stone_label">Gross wt</span><span className="stone_value">{formatStoneQty(productDetail.productdetails.grosswt)}g</span></div>
                    )}
                    {productDetail.productdetails.netwt && (
                      <div className="stone_info_row"><span className="stone_label">Net wt</span><span className="stone_value">{formatStoneQty(productDetail.productdetails.netwt)}g</span></div>
                    )}
                  </div>
                )}
              </div>
            )}

            <div className="stone_detail stone_details_section">
              <div className="stone_detail_header" onClick={() => setShowStoneDetails(p => !p)} style={{cursor:"pointer"}}>
                <b>Stone Details</b>
                <i className={`fa ${showStoneDetails ? "fa-angle-up" : "fa-angle-down"}`}></i>
              </div>

              {showStoneDetails && productDetail.Stones?.length > 0 ? (
                <div className="viewer_detail_body" style={{ paddingLeft: "1ch" }}>
                  {productDetail.Stones.map((stone, k) => (
                  <div key={k}>
                    {k > 0 && <hr className="stone_divider" />}
                    <div className="stone_info_row"><span className="stone_label">Stone</span><span className="stone_value">{stone.stone_name || "-"}</span></div>
                    <div className="stone_info_row"><span className="stone_label">Shape</span><span className="stone_value">{stone.Shape_name || "-"}</span></div>
                    <div className="stone_info_row"><span className="stone_label">Color</span><span className="stone_value">{stone.Color_name || "-"}</span></div>
                    <div className="stone_info_row"><span className="stone_label">Cut</span><span className="stone_value">{stone.Cut_name || "-"}</span></div>
                    <div className="stone_info_row"><span className="stone_label">Clarity</span><span className="stone_value">{stone.Clarity_name || "-"}</span></div>
                    <div className="stone_info_row"><span className="stone_label">Pcs</span><span className="stone_value">{formatStonePcs(stone.Pcs)}</span></div>
                    <div className="stone_info_row"><span className="stone_label">Weight</span><span className="stone_value">{Number(stone.Cts) ? `${formatStoneQty(stone.Cts)} ${stone.Unit || "ct"}` : "-"}</span></div>
                    <div className="stone_info_row"><span className="stone_label">Setting</span><span className="stone_value">{stone.Setting_type_name || "-"}</span></div>
                    {stone.certificate?.number && (
                      <div className="stone_info_row">
                        <span className="stone_label">Certificate</span>
                        <span className="stone_value">{stone.certificate.type} <i className="fa fa-external-link"></i> {stone.certificate.number}</span>
                      </div>
                    )}
                  </div>
                ))}
                </div>
              ) : ""}
            </div>





          </div>
        </div>
      </div>
    </>
  )


}

export default ProductViewer;